export default "__VITE_ASSET__DYF5d64v__"